import { AppBar } from "@mui/material";
import { Grid } from "@mui-wrapper";
import { DevFeaturesDialogButton } from "@components/dev-features-dialog/dev-features-dialog-button";
import { useLoggedInUser } from "@hooks/use-logged-in-user";
import { CreateWorkspace } from "@components/create-workspace";
import { UserMenuDropdown } from "@components/navbar/user-menu";
import { SubjectBreadcrumbs } from "@components/subject-breadcrumbs";
import { grey } from "@flat-ui";
import { AppRegionButton } from "@components/navbar/app-region-button";

export function NavBar(): React.JSX.Element {
  const { currentUser, currentUserRoles } = useLoggedInUser();

  return (
    <AppBar position="static" elevation={0}>
      <Grid
        container
        sx={{
          width: "100%",
          backgroundColor: grey[0],
          p: "6px 8px 6px 18px",
          justifyContent: "space-around",
          alignContent: "center",
        }}
      >
        <Grid size={6} container spacing={2} sx={{ alignItems: "center" }}>
          <SubjectBreadcrumbs />
        </Grid>

        <Grid
          size={6}
          container
          spacing={1}
          sx={{ justifyContent: "flex-end", alignItems: "center" }}
        >
          <Grid>
            <CreateWorkspace />
          </Grid>

          <DevFeaturesDialogButton currentUserRoles={currentUserRoles} />

          <AppRegionButton />

          <Grid>
            {currentUser && <UserMenuDropdown currentUser={currentUser} />}
          </Grid>
        </Grid>
      </Grid>
    </AppBar>
  );
}
